const DashboardSkeleton = () => {
  return (
    <div className="p-4 pb-24 animate-pulse">
      {/* User Profile Skeleton */}
      <div className="mb-6">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 bg-tg-secondary rounded-full"></div>
          <div className="flex-1">
            <div className="h-5 bg-tg-secondary rounded w-32 mb-2"></div>
            <div className="h-4 bg-tg-secondary rounded w-24"></div>
          </div>
        </div>
        <div className="bg-tg-secondary rounded-xl p-4">
          <div className="h-4 bg-gray-700 rounded w-20 mb-2"></div>
          <div className="h-8 bg-gray-700 rounded w-32"></div>
        </div>
      </div>

      {/* Quick Actions Skeleton */}
      <div className="mb-6">
        <div className="h-6 bg-tg-secondary rounded w-32 mb-3"></div>
        <div className="grid grid-cols-4 gap-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-tg-secondary rounded-xl p-4">
              <div className="h-8 w-8 bg-gray-700 rounded mx-auto mb-2"></div>
              <div className="h-3 bg-gray-700 rounded w-12 mx-auto"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Statistics Skeleton */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-tg-secondary rounded-xl p-4">
            <div className="h-3 bg-gray-700 rounded w-20 mx-auto mb-2"></div>
            <div className="h-6 bg-gray-700 rounded w-16 mx-auto"></div>
          </div>
        ))}
      </div>

      {/* Transactions Skeleton */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-3">
          <div className="h-6 bg-tg-secondary rounded w-40"></div>
          <div className="h-4 bg-tg-secondary rounded w-20"></div>
        </div>
        <div className="space-y-2">
          {[1, 2].map((i) => (
            <div key={i} className="bg-tg-secondary rounded-lg p-3">
              <div className="h-4 bg-gray-700 rounded w-24 mb-1"></div>
              <div className="h-3 bg-gray-700 rounded w-32"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;

